import { FC, useContext } from "react";
import NotFoundComponentProps from "./NotFoundComponentProps";
import "./NotFoundComponent.scss";

const NotFoundComponent: FC<NotFoundComponentProps> = ({ }) => {
    return <div className="not_found_component">
        <div className="container py-5">

            <h1 className="display-1 fw-bold text-apolo-blue">404</h1>

            <div className="mb-4">
                <img src="/assets/logo_white.png"/>
            </div>

            <h2 className="fs-2 fw-medium text-apolo-blue mb-3">
                Página No Encontrada
            </h2>
            <p className="lead mb-4">
                El enlace al que intentas acceder, verifica tu QR o pide ayuda en recepción.
            </p>

        </div>
    </div>
}

export default NotFoundComponent;